import { green, red, yellow } from "@mui/material/colors";

export const primaryColor = green[500];
export const wrongColor = red[500];
export const answeredColor = yellow[700];